const customers = {
  list: {
    search: 'ابحث عن اسم عميل او رقم الهاتف او البريد الالكتروني',
    noDataDescription: 'لا يوجد عملاء حالياً',
    employeeId: 'رقم العميل',
    name: 'الاسم',
    phoneNumber: 'رقم الهاتف',
    branchName: 'اسم الفرع',
    branch: 'الفرع',
    status: 'الحالة',
    filter: {
      filtersPlaceHolders: {
        filterByService: 'الخدمة',
        filterByCustomerStatus: 'الحالة',
        filterByBranchName: 'الفرع',
        filterByLocations: 'الموقع',
      },
    },
    statusCases: {
      active: 'نشط',
      blocked: 'محظور',
    },
    blockCustomer:'حظر عميل',
    blockCustomerMsg: 'هل أنت متأكد أنك تريد حظر هذا العميل؟',
    note:'لاحظ أن',
    blockCustomerNote:'سوف يتم إلغاء الحجوزات القادمة لهذا العميل.',
  },
  deleteCustomer: {
    title: 'حذف عميل',
    deleteConfirmationMsg: 'هل انت متأكد من حذف العميل؟',
  },
  errorMessages: {
    phoneRequired: 'رقم الهاتف مطلوب',
  },
  viewCustomer: {
    gender: 'الجنس',
    addresses: 'عناوين العميل المحفوظة',
    title: 'العنوان',
    country: 'الدولة',
    city: 'المدينة',
    region: 'المنطقة',
    streetName: 'اسم الشارع',
    buildingNumber: 'رقم المبنى',
    secondaryPhone: 'رقم الهاتف الثانوي',
    landmark: 'المعلم',
    email: 'البريد الالكتروني',
    noAddress: 'لا يوجد عناوين محفوظة',
    address: 'المكان',
    female:'أنثى',
    male:'ذكر'
  },
};

export default customers;
